export function isValidNewsItem(item) {
  if (!item?.slug || !item?.title || !item?.titleImageUrl) {
    return false;
  }

  const title = String(item.title).trim();
  const slug = String(item.slug).trim();
  const newsId = item.newsId != null ? String(item.newsId) : "";

  if (title.length < 3 || slug.length < 3) {
    return false;
  }

  if (
    newsId.includes("..") ||
    newsId.includes("/") ||
    newsId.includes("\\") ||
    newsId.toLowerCase().includes("apache")
  ) {
    return false;
  }

  return true;
}

export function filterValidNews(items) {
  return (items || []).filter(isValidNewsItem);
}
